import {
  object,
  string,
  array,
  number,
  SchemaOf,
  mixed,
  StringSchema,
} from 'yup';

import { KubernetesRbacFormValues, KubernetesUnifiedAccess } from './types';

const accessListValidationSchema: SchemaOf<KubernetesUnifiedAccess> = object({
  Id: number().min(1).required(),
  PartyId: number().min(1).required(),
  Type: mixed<KubernetesUnifiedAccess['Type']>().required(),
  Name: string().required(),
  Role: object({
    Id: number().min(1).required(),
    Name: string().required(),
  }).required(),
  namespaces: array().of(string().required()).optional(),
});

export function createKubernetesRBACValidationSchema(
  nameValidation: StringSchema<string>
): SchemaOf<KubernetesRbacFormValues> {
  return object({
    name: nameValidation,
    environmentGroupIds: array(number().required()),
    accessList: array(accessListValidationSchema)
      .required('At least one user or team access is required')
      .min(1, 'At least one user or team access is required'),
  });
}
